import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container } from "react-bootstrap";
import CartContext from "./Components/Marketing/CartContext";
import React, { createContext, useContext, useEffect, useState } from "react";
import Navigation from "./Components/Marketing/Navigation";
import { Layout } from "./Components/Layout";
import { Home } from "./Components/Marketing/Home";
import { Footer } from "./Components/Marketing/Footer";
import { Products } from "./Components/Marketing/Products";
import { Pricing } from "./Components/Marketing/Pricing";
import { Showcase } from "./Components/Marketing/Showcase";
import { Themes } from "./Components/Marketing/Themes";
import { Solutions } from "./Components/Marketing/Solutions";

import { SupplyChain } from "./Components/Marketing/SupplyChain";
import { Erp, ERP } from "./Components/Marketing/ERP";
import { POS } from "./Components/Marketing/POS";
import { Kiosk } from "./Components/Marketing/Kiosk";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CartProvider } from "./Components/Marketing/CartContext";
import { VisitorsCount } from "./Components/Marketing/VisitorsCount";
import { Checkout } from "./Components/Marketing/Checkout";
import UserProfile from "./Components/Marketing/UserProfile";
import UserOrders from "./Components/Marketing/UserOrders";
import CompleteOrder from "./Components/Marketing/CompleteOrder";
import UserProducts from "./Components/Marketing/UserProducts";

import { PosRestaurant } from "./Components/Marketing/POSRestaurant";
import { ECommerceB2B } from "./Components/Marketing/ECommerceB2B";
import { ECommerceB2CRetail } from "./Components/Marketing/ECommerceB2cRetail";
import { ECommerceB2CRestaurant } from "./Components/Marketing/ECommerceB2cRestaurant";
import { QRCodePos } from "./Components/Marketing/QrcodePOS";
import { ErpRetail } from "./Components/Marketing/ErpRetail";
import { ErpRestaurant } from "./Components/Marketing/ErpRestaurant";
import { ErpManufacturing } from "./Components/Marketing/ErpManufacturing";
import { ErpServicing } from "./Components/Marketing/ErpService";
import { SolutionECommerce } from "./Components/Marketing/SolutionECommerce";
import { SolutionRetail } from "./Components/Marketing/SolutionRetail";
import { SolutionRestaurant } from "./Components/Marketing/SolutionRestaurant";
import { SolutionManufacturing } from "./Components/Marketing/SolutionManufacturing";
import { SolutionServicing } from "./Components/Marketing/SolutionServicing";
import { UpgradeProduct } from "./Components/Marketing/UpgradeProduct";
import { RenewProduct } from "./Components/Marketing/RenewProduct";
import TermsAndConditions, {
  ContactUs,
  PrivacyPolicy,
} from "./Components/Marketing/Compliance";
import Settings from "./Components/Marketing/Settings";
import { CrmModule } from "./Components/Marketing/CommonModules";
import CrmSales from "./Components/Marketing/CRM";
import { ECommerce } from "./Components/Marketing/ECommerce";
import { Production } from "./Components/Marketing/Production";
import Warehouse from "./Components/Marketing/Warehouse";
import Hrm from "./Components/Marketing/HRM";
import Accounting from "./Components/Marketing/Accounting";

function App() {
  const [windowDimension, setWindowDimension] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setWindowDimension(window.innerWidth);
    // if (window.innerWidth <= 640) {
    if (window.innerWidth <= 1100) {
      setIsMobile(true);
    }
  }, []);

  return (
    <Container fluid className="m-0 p-0 w-100">
      <CartProvider>
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="solutions" element={<Solutions />} />
              <Route path="Products" element={<Products />} />

              <Route path="CompleteOrder" element={<CompleteOrder />} />
              <Route path="MyProducts" element={<UserProducts />} />
              <Route path="MyOrders" element={<UserOrders />} />
              <Route path="UserProfile" element={<UserProfile />} />
              <Route path="Checkout" element={<Checkout />} />
              <Route path="POS" element={<POS />} />
              <Route path="PosRestaurant" element={<PosRestaurant />} />
              <Route path="ECommerce" element={<ECommerce />} />
              <Route
                path="ECommerceB2CRetail"
                element={<ECommerceB2CRetail />}
              />
              <Route
                path="ECommerceB2CRestaurant"
                element={<ECommerceB2CRestaurant />}
              />
              <Route path="ECommerceB2B" element={<ECommerceB2B />} />
              <Route path="Kiosk" element={<Kiosk />} />
              <Route path="QRCodePos" element={<QRCodePos />} />
              <Route path="Erp" element={<Erp />} />
              <Route path="CrmSales" element={<CrmSales />} />
              <Route path="ErpRetail" element={<ErpRetail />} />
              <Route path="ErpRestaurant" element={<ErpRestaurant />} />
              <Route path="ErpManufacturing" element={<ErpManufacturing />} />
              <Route path="ErpServicing" element={<ErpServicing />} />
              <Route path="themes" element={<Themes />} />
              <Route path="showcase" element={<Showcase />} />
              <Route path="Pricing" element={<Pricing />} />
              <Route path="UpgradeProduct" element={<UpgradeProduct />} />
              <Route path="RenewProduct" element={<RenewProduct />} />
              <Route path="SolutionECommerce" element={<SolutionECommerce />} />
              <Route path="SolutionRetail" element={<SolutionRetail />} />
              <Route
                path="SolutionRestaurant"
                element={<SolutionRestaurant />}
              />
              <Route
                path="SolutionManufacturing"
                element={<SolutionManufacturing />}
              />
              <Route path="SolutionServicing" element={<SolutionServicing />} />

              <Route path="SupplyChain" element={<SupplyChain />} />
              <Route path="Warehouse" element={<Warehouse />} />
              <Route path="HRM" element={<Hrm />} />
              <Route path="Accounting" element={<Accounting />} />

              <Route path="Production" element={<Production />} />
              <Route path="VisitorsCount" element={<VisitorsCount />} />

              <Route
                path="TermsAndConditions"
                element={<TermsAndConditions />}
              />
              <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="ContactUs" element={<ContactUs />} />

              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
          <Footer></Footer>
        </BrowserRouter>
      </CartProvider>
    </Container>
  );
}

export default App;
